import { render } from "./entity_documents.html?vue&type=template&id=bac727aa&external"
import script from "./entity_documents.js?vue&type=script&lang=js&external"
export * from "./entity_documents.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__